import React, { Fragment, useContext, useState, memo } from "react";
import { openLayerFn, pickerStartFn2 } from "../../Layout";

export const LayerBox = () => {

    return (
        <div className="blacklayer-container" id="layerBox">
            <div className="bl-blind"></div>
            <div className="in-layerarea nobtn">
                <div>
                    <div className="blgrn-box vertical">
                        <div className="blgr-title">메모</div>

                        <div className="inlayer-memo-area">
                            <textarea className="textarea-box" placeholder="메모를 입력해 주세요." id="memoPopupValue" />
                        </div>

                        <div className="tbns-area">
                            <a href={void 0} className="btn-round gray">
                                취소
                            </a>
                            <a className="btn-round wht">
                                확인
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export const MealSelectDate = () => {
  const [selected, setSelected] = useState("식사 후");
  const [isOn, setIsOn] = useState(false);

  const toggleOn = () => {
    setIsOn(prev => !prev);
  };

  return (
    <div className="meal-select-date">
      <div className="select-input">
        <div>
          <div
            className={`select-custom-box bfaf-select ${isOn ? "on" : ""}`}
            onClick={() => toggleOn()}>
            <a className="btn-select">식사 후</a>
            <ul>
              <li>
                <a onClick={e => showAfInput(e, "B")}>식사 전</a>
              </li>
              <li>
                <a onClick={e => showAfInput(e, "A")}>식사 후</a>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <input
            type="text"
            className="textbox datetime-picker-input pick-result"
            placeholder="날짜/시간을 선택해 주세요."
            readOnly
          />
        </div>
      </div>
      <div className="under-oninput toggle" id="afTime">
        <input
          type="text"
          className="textbox aftermeal-picker-input pick-result2"
          data-num="2"
          placeholder="식후 시간을 선택해주세요. "
          readOnly
        />
      </div>
    </div>
  );
} 

